module.exports = __webpack_public_path__ + "static/media/Christianity Explored Card.982724f2.png";